import { render, staticRenderFns } from "./Page009.vue?vue&type=template&id=5b3ab7f0&scoped=true&"
import script from "./Page009.vue?vue&type=script&lang=js&"
export * from "./Page009.vue?vue&type=script&lang=js&"
import style0 from "./Page009.vue?vue&type=style&index=0&id=5b3ab7f0&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b3ab7f0",
  null
  
)

export default component.exports